import { render } from "./DAO.vue?vue&type=template&id=ff9063a2&scoped=true"
import script from "./DAO.vue?vue&type=script&lang=js"
export * from "./DAO.vue?vue&type=script&lang=js"

import "./DAO.vue?vue&type=style&index=0&id=ff9063a2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff9063a2"]])

export default __exports__